/** Owner supplies the App Store record URL before submission. */
export const APP_STORE_URL: string | null = null;
export const OWNER_CONTACT_EMAIL: string | null = "info.leeseidon@gmail.com";
export function storeListing(platform: string, appleUrl: string | null = APP_STORE_URL): string | null {
  if (appleUrl !== null && !/^https:\/\/apps\.apple\.com\//.test(appleUrl)) appleUrl = null;
  return platform === "android" ? "https://play.google.com/store/apps/details?id=com.tidetally.app" : platform === "ios" ? appleUrl : null;
}
